import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../_services/api/_api.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
    selector: 'app-top-nav',
    templateUrl: './topnav.component.html',
})

export class TopNavComponent implements OnInit {
    email: string;
    // foto: string;
    showTopBanner = false;
    envName: string;
    profileOpen = false;

    constructor(private _auth: AuthService, private _api: ApiService, private _router: Router) { }

    ngOnInit() {
        this._api.account().getMe().subscribe(res => {
            this.email = res.email;
            // this.foto = res.fotoHeader + res.foto;
            this.showTopBanner = res.showTopBanner;
            this.envName = res.envName;
        });
    }

    toggleProfileOpen() {
        this.profileOpen = !this.profileOpen;
    }

    sidebarToggler(): void {
        let sidebar: any = document.querySelector('#sidebar');
		let mainContainer: any = document.querySelector('.main-container');
		sidebar.toggleClass('sidebar-left-zero');
		mainContainer.toggleClass('main-container-ml-zero');
    }

    logoutClicked() {
        this._auth.logout();
        this._router.navigate(['/']);
    }
}
